<script>
export default {
  props: ['title', 'mode'],
  methods: {
    fechar () {
      this.$emit('onClose')
    }
  }
}
</script>

<template>
  <div :class="{'v-card theme--light': mode === 'modal'}">
    <v-card-title class="headline grey lighten-2" primary-title v-show="mode === 'modal'">
      <v-layout row wrap>
        <v-flex class="text-title"> {{ title }} </v-flex>
        <v-flex xs2 class="btn-right">
          <v-btn right icon @click="fechar">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="card-form">
      <slot></slot>
    </v-card-text>
  </div>
</template>

<style scoped>
  .text-title {
    text-align: left;
    line-height: 45px;
  }
  .btn-right {
    text-align: right;
    padding: 0px;
  }
  .card-form {
    text-align: left;
  }
</style>
